export function localDateFormat(
  Datetime: Date | string,
  format: string,
): string {
  const [date, time] = Datetime.toString().split('T');

  let formatStrategy: Record<string, string> = {};

  if (date) {
    const [year, month, day] = date.split('-');
  }
  if (time) {
    const [hour, minutes, secondsWithTimezone] = time.split(':');
    const [seconds, timezone] = secondsWithTimezone.split('.');

    formatStrategy = {
      'HH:mm': hour + ':' + minutes,
    };
  }

  return formatStrategy[format];
}

